import { render, staticRenderFns } from "./page_navigation.vue?vue&type=template&id=5a6ae508&scoped=true"
import script from "./page_navigation.vue?vue&type=script&lang=js"
export * from "./page_navigation.vue?vue&type=script&lang=js"
import style0 from "./page_navigation.vue?vue&type=style&index=0&id=5a6ae508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ae508",
  null
  
)

export default component.exports